<template>
  <div>
    <component :is="paymentComponent" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PaymentSuccessMPC from './PaymentInformation/PaymentInfoMpc';
import PaymentSuccessMCAPP from './PaymentInformation/PaymentInfoMca';

export default {
  name: 'PaymentInfo',
  computed: {
    ...mapGetters(['isMCA']),
    paymentComponent() {
      return this.isMCA
        ? PaymentSuccessMCAPP
        : PaymentSuccessMPC;
    }
  }
};
</script>
